import { useState } from 'react';
import { ThemeProvider } from './contexts/ThemeContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ToolGrid from './components/ToolGrid';
import ToolPanel from './components/ToolPanel';
import CategoryTabs from './components/CategoryTabs';
import { Tool, TabKey } from './types';
import './App.css';

function App() {
    const [selectedTool, setSelectedTool] = useState<Tool | null>(null);
    const [query, setQuery] = useState('');
    const [activeCategory, setActiveCategory] = useState<TabKey>('all');

    // 收藏状态：从 localStorage 初始化
    const [favorites, setFavorites] = useState<string[]>(() => {
        try {
            const saved = localStorage.getItem('favoriteTools');
            return saved ? JSON.parse(saved) : [];
        } catch {
            return [];
        }
    });

    // 切换收藏状态
    const toggleFavorite = (toolId: string) => {
        setFavorites(prev => {
            const next = prev.includes(toolId)
                ? prev.filter(id => id !== toolId)
                : [...prev, toolId];
            localStorage.setItem('favoriteTools', JSON.stringify(next));
            return next;
        });
    };

    return (
        <ThemeProvider>
            <div className="app">
                <Header query={query} onQueryChange={setQuery} />
                <main className="main-content">
                    <CategoryTabs active={activeCategory} onChange={setActiveCategory} />
                    <ToolGrid
                        onToolClick={setSelectedTool}
                        query={query}
                        category={activeCategory}
                        favorites={favorites}
                        onToggleFavorite={toggleFavorite}
                    />
                </main>
                <Footer />
                {selectedTool && (
                    <ToolPanel
                        tool={selectedTool}
                        onClose={() => setSelectedTool(null)}
                    />
                )}
            </div>
        </ThemeProvider>
    );
}

export default App;
